import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function WhereNext({ items, heading = "Where to next?" }) {
  return (
    <section className="pb-24 md:pb-32" data-testid="where-next">
      <div className="container mx-auto px-6 md:px-12">
        <h2 className="font-heading text-2xl md:text-3xl font-bold tracking-tight text-[#0F172A] mb-8">{heading}</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((it, i) => (
            <motion.div
              key={it.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
            >
              <Link
                to={it.to}
                className="group flex flex-col h-full bg-white rounded-[1.5rem] p-6 border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 hover:border-[#0EA5E9]/40 transition-all duration-300"
                data-testid={`where-next-${i}`}
              >
                <p className="text-sm text-[#64748B]">{it.sub}</p>
                <p className="mt-1 font-heading text-lg font-semibold text-[#0F172A] leading-snug flex-1">{it.label}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-[#0EA5E9] font-bold group-hover:gap-3 transition-all">
                  Go <ArrowRight size={16} />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
